import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_REGION, GET_REGION_SUCCESS, GET_REGION_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getRegion({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/regions`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageIndex: 0,
        pageSize: 1000,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_REGION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_REGION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_REGION_ERROR, payload: error });
  }
}

export function* watchGetRegion() {
  yield takeEvery(GET_REGION, getRegion);
}

function* getRegionSaga() {
  yield all([fork(watchGetRegion)]);
}

export default getRegionSaga;
